import './index.styl'

const CONSULT_DIALOG_ID = 'consult-dialog'
const CONSULT_DIALOG_CLOSE_ID = 'consult-dialog-close'

const ConsultDialogPlugin = (Vue, options) => {
  Vue.prototype.$consultDialog = {
    init(common) {
      const dom = document.getElementById(CONSULT_DIALOG_ID)
      let qrcodeClass = common.useOrgQrcode ? 'container-box qrcodebg' : 'container-box noQrcodeBg'
      let qrcodeDomText1 = common.useOrgQrcode ?`<img class="qrcode" src="${common.orgQrcode}" alt=""/>`:''
      let qrcodeDomText2 = common.useOrgQrcode ? `<div class="desc">长按识别二维码</div>` : ''
      let qrcodeClose = !common.useOrgQrcode ? `top:7rem;` : ''
      let domText = `
        <div id="${CONSULT_DIALOG_ID}" class="consult-mask">
          <div class="${qrcodeClass}">
            <div class="title">${common.orgName}</div>
            <div class="phone">
              <img src="http://image.wxopen.shenhudong.com/20210518/fdcf7afcd0ff593f481636444098b49e.png?x-oss-process=style/uploadimg" alt=""/>
              <a href="tel:${common.orgPhone}">${common.orgPhone}</a>
            </div>
                ${qrcodeDomText1}
                ${qrcodeDomText2}
            <img id="${CONSULT_DIALOG_CLOSE_ID}" style="${qrcodeClose}" class="closeBtn" src="http://image.wxopen.shenhudong.com/20210517/5debf8dacf2b0d751b1cba489be56d04.png?x-oss-process=style/uploadimg" alt=""/>
          </div>
        </div>
      `
      let qrcodeRes = document.body.insertAdjacentHTML('beforeEnd',domText)
      $(`#${CONSULT_DIALOG_CLOSE_ID}`).off().click(() => {
        this.hide()
      })
      return qrcodeRes
    },
    show(){
      $(`#${CONSULT_DIALOG_ID}`).show()
    },
    hide(){
      $(`#${CONSULT_DIALOG_ID}`).hide()
    }
  }

}

export default ConsultDialogPlugin